'use client';

export { default } from './SpeedDialIcon';
export { default as speedDialIconClasses } from './speedDialIconClasses';
export * from './speedDialIconClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/SpeedDialIcon/index.js
// module id = 956
// module chunks = 25